export enum SearchByEnum {
  NAME = 'NAME',
  CODE_NAME = 'CODE_NAME',
}
